import React from "react";
import AttendancePolicyComponent from "../../../AttendancePolicyComponent";

const ShiftStructureTab = ({
  darkMode,
  branchesList,
  departmentsList,
  designationsList,
  subDepartmentsList,
  gradesList,
  categoriesList,
}) => {
  return (
    <div className={darkMode ? "text-white" : "text-slate-900"}>
      <AttendancePolicyComponent
        darkMode={darkMode}
        mode="shift"
        branchesList={branchesList}
        departmentsList={departmentsList}
        designationsList={designationsList}
        subDepartmentsList={subDepartmentsList}
        gradesList={gradesList}
        categoriesList={categoriesList}
      />
    </div>
  );
};

export default ShiftStructureTab;
